export default "__VITE_ASSET__5d4dec6c__"